export default {
  couponReadList: {
    感謝惠顧: "感謝惠顧",
    X已為你送上Y張優惠券: "{X}已為你送上{Y}張優惠券",
    有效期: "有效期:",
    查看優惠券: "查看優惠券",
    關閉窗口: "關閉窗口",
  },
};
